var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersManagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/Info/User_Management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.40248761,16 L2.29054935,15.9964718 C1.40247732,15.9402969 0.7,15.2203388 0.7,14.3404443 C0.7,14.243857 0.708650173,14.1474541 0.725852006,14.0523335 C1.29593414,10.8999626 3.90481574,8.4924465 7.1153244,8.06702485 L7.37692593,8.03689915 C7.53729292,8.01275992 7.72269158,8 7.93231538,8 L8.13435129,8 C8.31291971,8 8.47390912,8.00925926 8.6179941,8.02623457 L8.69073552,8.0369966 C12.019886,8.36334297 14.7553832,10.8150858 15.3408147,14.0523335 C15.3580165,14.1474541 15.3666667,14.243857 15.3666667,14.3404443 C15.3666667,15.2203388 14.6641894,15.9402969 13.7761173,15.9964718 L13.6641791,16 L2.40248761,16 Z M13.6963725,14.6666667 C13.8811976,14.6666667 14.0310301,14.5206157 14.0310301,14.3404443 C14.0310301,14.3214575 14.0293297,14.3025069 14.0259482,14.2838084 C13.517169,11.4704228 11.0201975,9.38086328 8.06567941,9.33413309 C5.11083265,9.38086328 2.61386114,11.4704228 2.1050819,14.2838084 L2.1,14.3404443 L2.1,14.3404443 C2.1,14.4980943 2.21471554,14.6296232 2.36721278,14.66004 L2.43465762,14.6666667 L13.6963725,14.6666667 Z M8,7 C9.93299662,7 11.5,5.43299662 11.5,3.5 C11.5,1.56700338 9.93299662,0 8,0 C6.06700338,0 4.5,1.56700338 4.5,3.5 C4.5,5.43299662 6.06700338,7 8,7 Z",
    id: "Shape",
    fill: "#3368FF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersManagement);
export default __webpack_public_path__ + "static/media/users-management.822425c94f2b8ef3f7e6ab65f7bdcd57.svg";
export { ForwardRef as ReactComponent };